import { useCreateAccount } from 'modules/sendingPlatforms/hooks';
import { FieldValues, useFormContext } from 'react-hook-form';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { useModalsContext } from '../../../contexts';

type Props = {
  children: React.ReactNode;
  headerText: string;
  onSubmit: (data: FieldValues) => void;
};

export const CreateModalRHF = ({ children, headerText, onSubmit }: Props) => {
  const { hideModal } = useModalsContext();
  const { isLoading } = useCreateAccount();
  const {
    handleSubmit,
    formState: { isValid, isDirty },
  } = useFormContext();

  return (
    <Modal
      id="create-account-modal"
      isModalOpen={true}
      onClose={hideModal}
      size={MODAL_SIZES.MEDIUM}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>{headerText}</ModalHeader>
      <ModalBody>
        {/* Form fields passed through children */}
        {children}
      </ModalBody>
      <ModalFooter>
        <PrimaryButton
          isDisabled={!(isValid && isDirty)}
          isLoading={isLoading}
          onClick={handleSubmit(onSubmit)}
          size={BUTTON_SIZES.LARGE}
        >
          Connect account
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
